import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import type { StoredDictionary } from "../../utils/dictionary-storage";
import { restoreStoredDictionary } from "../../utils/dictionary-storage";

export const DictionaryRemovedDialog = ({
  removedDictionary,
  onDismiss,
}: {
  removedDictionary: StoredDictionary | undefined;
  onDismiss: () => void;
}) => {
  const open = removedDictionary !== undefined;
  const filename = removedDictionary?.filename ?? "";

  const handleRestore = () => {
    if (removedDictionary) restoreStoredDictionary(removedDictionary);
    onDismiss();
  };

  return (
    <Dialog
      aria-labelledby="dictionary-removed-dialog-title"
      open={open}
      onClose={onDismiss}
    >
      <DialogTitle id="dictionary-removed-dialog-title">
        Dictionary removed in another tab
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <strong>{filename}</strong> was removed from the saved list in another
          browser tab. It is still active here. Restore it to your saved list?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="inherit" onClick={onDismiss}>
          Keep removed
        </Button>
        <Button autoFocus variant="contained" onClick={handleRestore}>
          Restore
        </Button>
      </DialogActions>
    </Dialog>
  );
};
